import React from "react";
import { Col, Divider, Form, List, Row, Select, Skeleton, Space } from "antd";
import monitoringResultsStyles from "./AdminMonitoringResults.module.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { Content } from "antd/lib/layout/layout";
import AdminSmallMetric from "./Metrics/AdminSmallMetric/AdminSmallMetric";
import { useUserStore } from "../../../context/UserStore";

export default function AdminMonitoringResults() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    area_id: null,
    metric_year: null,
    unit_id: null,
  });
  const areaIdOptions = [
    { value: "", label: "All Areas" },
    { value: 0, label: "Service" },
    { value: 1, label: "Quality" },
    { value: 2, label: "Safety" },
    { value: 3, label: "Financial" },
    { value: 4, label: "People" },
  ];
  const [loadingMetrics, setLoadingMetrics] = useState(true);
  const [loadingUnits, setLoadingUnits] = useState(true);
  const [metrics, setMetrics] = useState([]);
  const [unitChoices, setUnitChoices] = useState([]);
  const [yearChoices, setYearChoices] = useState([]);
  const user = useUserStore((state) => state.user);
  const me = useUserStore((state) => state.me);

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 8,
    },
  };

  // Removes Metric by ID from metrics array
  const removeMetric = (metricId) => {
    setMetrics(metrics.filter((metric) => metric.id !== metricId));
  };

  const getMetricData = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/admin/metrics`,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        type: "json",
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((response) => {
        setMetrics(
          response.metrics.data.map((item) => {
            return {
              ...item,
              key: item.id,
            };
          }),
        );
        setLoadingMetrics(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getUnitOptions = async (value) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/admin/hospitals/${me.attributes.hospital_id}/units/list`,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        type: "json",
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((response) => {
        unitChoices.push({ label: "All Units", value: "" });
        for (let i = 0; i < response.units.data.length; i++) {
          unitChoices.push({
            label: response.units.data[i].attributes.name,
            value: response.units.data[i].id,
          });
        }
        setLoadingUnits(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onFinish = (values) => {};
  const onFinishFailed = (errorInfo) => {};

  const yearmax = new Date().getFullYear() + 1;
  const setYearOptions = () => {
    let yearOptions = [];
    yearOptions.push({ value: "", label: "All Years" });
    for (var i = yearmax; i > 1985; i--) {
      yearOptions.push({ value: i, label: i });
    }

    setYearChoices(yearOptions);
  };

  const onFieldsChange = (changedFields, allFields) => {
    changedFields.map((field) => {
      setFormData({ ...formData, [field.name[0]]: field.value });
    });
    searchMetrics(formData);
  };

  const searchMetrics = async (formData) => {
    setLoadingMetrics(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/admin/metrics/search`,
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({
          search: formData,
        }),
        type: "json",
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((response) => {
        setMetrics(response.metrics.data);
        setLoadingMetrics(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getUnitOptions();
    setYearOptions();
    getMetricData();
  }, []);

  return (
    <>
      <div
        className={`py-5 mb-5 flex flex-col items-center justify-center ${monitoringResultsStyles.headerBar}`}
      >
        <h1 className="text-4xl text-center text-white">Monitoring Results</h1>
      </div>
      <div className="max-w-sm rounded overflow-hidden mb-4 flex justify-center md:justify-start">
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold px-2 py-1 text-sm md:px-4 md:py-2 md:text-base rounded flex items-center justify-center"
          onClick={() => navigate("/admin/monitoring-results/metrics/new")}
        >
          <svg
            className="w-4 h-4 mr-2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M12 4v16m8-8H4"></path>
          </svg>
          New Metrics
        </button>
      </div>

      <Divider />
      <Space />
      <Content className="mt-2">
        <Skeleton loading={loadingUnits} active>
          <Form
            form={form}
            layout={layout}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row>
              <Col span={5}>
                <Form.Item name="metric_year">
                  <Select
                    onChange={(value) => {
                      setFormData({
                        ...formData,
                        metric_year: value,
                        goal_year: value,
                      });
                      searchMetrics({
                        ...formData,
                        metric_year: value,
                        goal_year: value,
                      });
                    }}
                    placeholder="Select Year"
                    style={{ width: "100%" }}
                    options={yearChoices}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item name="area_id">
                  <Select
                    onChange={(value) => {
                      setFormData({
                        ...formData,
                        area_id: value,
                        type_id: value,
                      });
                      searchMetrics({
                        ...formData,
                        area_id: value,
                        type_id: value,
                      });
                    }}
                    placeholder="Select Area"
                    style={{ width: "100%" }}
                    options={areaIdOptions}
                  />
                </Form.Item>
              </Col>

              <Col span={5}>
                <Form.Item name="unit_id">
                  <Select
                    onChange={(value) => {
                      setFormData({ ...formData, unit_id: value });
                      searchMetrics({ ...formData, unit_id: value });
                    }}
                    placeholder="Select Unit"
                    style={{ width: "100%" }}
                    options={unitChoices}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Skeleton>
        <Skeleton loading={loadingMetrics} active>
          <List
            itemLayout="horizontal"
            dataSource={metrics}
            renderItem={(metric) => (
              <AdminSmallMetric
                removeMetric={removeMetric}
                key={metric.id}
                metric={metric}
              />
            )}
          />
        </Skeleton>
      </Content>
    </>
  );
}
